import React, { FC } from 'react';
import KDSStylingSettings from './Components/StylingSettings';
import KDSSettingsList from './Components/KDSSettings';
import { Box } from '~Styles';

const KDSSettings: FC = () => {
  return (
    <Box padding="large" display="flex" flexDirection="column" gap="large">
      <Box marginBottom="xl">
        <KDSSettingsList />
      </Box>
      <KDSStylingSettings />
    </Box>
  );
};

export default KDSSettings;
